import { HTMLAttributes } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Control, FieldValues, UseFormHandleSubmit } from 'react-hook-form';
import ControlledButton from 'typescript/components/forms/controlled_button';
import { isOrderFree } from 'typescript/utilities/order_data';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';
import { useGetOrderSummary } from 'typescript/hooks/use_order_actions_client';
import { CHECKOUT_ROUTES } from 'typescript/constants/enums/checkout';
import { useCompleteOrderContext } from 'typescript/context/complete_order_context';

interface DeliveryPageCTAProps extends HTMLAttributes<HTMLElement> {
  control: Control;
  canContinue?: boolean;
  isLoading?: boolean;
  handleSubmit: UseFormHandleSubmit<FieldValues, undefined>;
}

const DeliveryPageCTA = ({
  className,
  control,
  canContinue = false,
  isLoading = false,
  handleSubmit,
}: DeliveryPageCTAProps) => {
  const { t } = useTranslation();
  const { orderNumber } = useCheckoutFlow();
  const { orderSummaryData } = useGetOrderSummary({ orderNumber });
  const { setShowRecaptcha } = useCompleteOrderContext();
  const history = useHistory();

  const onContinueToPayment = () => {
    if (canContinue) {
      history.push(CHECKOUT_ROUTES.PAYMENT);
    }
  };

  if (isOrderFree(orderSummaryData?.payment_due)) {
    return (
      <ControlledButton
        className={className}
        control={control}
        name="submit"
        isLoading={isLoading}
        onClick={handleSubmit(() => setShowRecaptcha(true))}
        label={t('checkout.delivery.cta.completeOrder')}
      />
    );
  }

  return (
    <ControlledButton
      className={className}
      control={control}
      name="submit"
      isLoading={isLoading}
      onClick={handleSubmit(onContinueToPayment)}
      label={t('checkout.delivery.cta.continueToPayment')}
    />
  );
};

export default DeliveryPageCTA;
